import React, { FC, useEffect, useState } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-back.svg';
import { Link, useLocation } from 'react-router-dom';
import { RightSideBarListType } from 'components/right-sidebar';

type BottomNavigationProps = {
  onConfirm: () => void;
  list: RightSideBarListType[];
  onNextClick?: () => void;
  backBtnDisabled?: boolean;
  loading?: boolean;
  disabled?: boolean;
  onNextText?: string;
};
const BottomNavigation: FC<BottomNavigationProps> = ({
  onConfirm,
  list = [],
  backBtnDisabled,
  loading,
  onNextClick,
  disabled
}) => {
  const [index, setIndex] = useState(0);

  const isLastIndex = () => {
    return list.length - 1 === index;
  };

  const getPrevRoute = () => {
    if (index !== 0) return `${list[index - 1]?.link}`;
    return '..';
  };

  const getNextRoute = () => {
    if (!isLastIndex()) return `${list[index + 1]?.link}`;
    return '..';
  };

  const location = useLocation();

  const getCurrentIdx = () => {
    const pathname = location.pathname;
    const currentIndex = list.findIndex(({ link }) => link === pathname);
    setIndex(currentIndex);
  };

  useEffect(() => {
    getCurrentIdx();
  }, [location]);

  const backIsDisabled = () => {
    return index === 0 || backBtnDisabled;
  };

  return (
    <div className='flex gap-4 items-center w-full mt-12'>
      <Link
        to={getPrevRoute()}
        replace
        className={`${
          backIsDisabled()
            ? 'pointer-events-none cursor-not-allowed bg-opacity-50 text-opacity-40'
            : 'cursor-pointer'
        } inline-block w-9 h-9 bg-[#F5F4F4] px-[9px] text-[#B6AFAF] rounded-full hover:bg-gray-13 transition-all`}>
        <div className='w-full flex justify-center items-center h-full'>
          <ArrowBackIcon className={`${!backIsDisabled() ? 'text-gray-6' : 'text-gray-3'}`} />
        </div>
      </Link>

      <div className='ml-auto flex gap-5'>
        {isLastIndex() ? (
          <Button
            onClick={onConfirm}
            small
            variant='block'
            color='primary'
            className='text-xs'
            disabled={disabled}
            loading={loading}>
            Confirm
          </Button>
        ) : (
          <Link to={getNextRoute()} className={`${disabled ? 'pointer-events-none' : ''}`} replace>
            <Button
              onClick={onNextClick}
              disabled={disabled}
              small
              variant='block'
              color='primary'
              className='text-xs'>
              Continue
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default BottomNavigation;
